import { addOrUpdateCustomer } from './helpers'
import { CustomersAction } from './actions'
import { Customer } from './types'

export interface State {
  customers?: Customer[]
  pending: boolean
  error: boolean
}

export const initialState: State = {
  customers: undefined,
  pending: true,
  error: false
}

export default (state = initialState, action: CustomersAction): State => {
  switch (action.type) {
    case 'customers.fetch':
      return {
        ...state,
        pending: true,
        customers: undefined,
        error: false
      }
    case 'customers.fetchFail':
      return {
        ...state,
        pending: false,
        error: true
      }

    case 'customers.addCustomers':
      let items: Customer[] = []

      if ('payload' in action) {
        items = action.payload ?? []
      }

      if (!state.customers) {
        return {
          ...state,
          customers: items
        }
      }

      return {
        ...state,
        customers: addOrUpdateCustomer(state.customers, items)
      }

    default:
      return state
  }
}
